export interface IThemeConfig {
  primary: string
  primary80: string
  primary60: string
  primary20: string
  onPrimary: string
  surface: string
  onSurface: string
  surfaceAvatar: string
  onSurfaceAvatar: string
  surfaceVariant: string
  selectedGroup: string
  selectedItem: string
  selectedItemHover: string
  onSelectedItem: string
  surfaceContainer: string
  surfaceLogo: string
  organizationLogo?: string
}

export enum ThemeColorsEnum {
  DEFAULT = '#009DFF',
}
